import React, { useState } from "react";
import { Plus, Minus, MapPin } from "lucide-react";

const FAQS = [
  ["Do you replace our existing cameras?", "Not necessarily. We assess what you have, integrate compatible equipment, and add or upgrade only what's needed so a live guard can actively monitor your community."],
  ["How fast do your guards respond?", "Our guards watch live, so engagement is immediate — often a real-time voice-down within seconds. When police are needed, our calls are verified and eyes-on, which means faster priority response."],
  ["Is this AI or real people?", "Both. AI helps surface activity instantly, but a dedicated, licensed virtual guard makes the judgment calls and takes action. You're never relying on software alone."],
  ["How is resident privacy handled?", "Monitoring focuses on common areas — gates, lobbies, corridors, garages and amenities — not private residences. Footage and access are handled under strict, documented protocols."],
  ["What does it cost?", "Pricing depends on your community's size and layout. Because we take a limited number of premium communities, we scope each engagement in a short consultation — request one and we'll prepare a tailored proposal."],
  ["Which communities do you serve?", "Luxury condominium and multi-family communities across Austin and Central Texas. We intentionally protect a limited number at a time."],
];

const Coverage = () => (
  <section className="relative bg-[#0F172A] text-white py-20 lg:py-24 overflow-hidden">
    <div className="pointer-events-none absolute -right-40 -top-20 w-[600px] h-[600px] rounded-full"
         style={{ background: "radial-gradient(circle, rgba(211,47,47,0.18), transparent 70%)" }} />
    <div className="max-w-7xl mx-auto px-6 relative text-center">
      <div data-reveal className="inline-flex items-center gap-2 mb-5 text-xs font-semibold uppercase tracking-[0.2em] text-[#FF6B6B]">
        <MapPin className="w-4 h-4" /> Service Area
      </div>
      <h2 data-reveal className="font-head text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-tight">
        Proudly protecting <span className="text-[#FF5252]">Austin &amp; Central Texas.</span>
      </h2>
      <p data-reveal className="text-white/55 mt-5 text-lg max-w-2xl mx-auto">
        We protect a limited number of luxury communities at a time — so every property gets a guard who truly knows it.
      </p>
    </div>
  </section>
);

const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="bg-white py-24 lg:py-32">
      <div className="max-w-3xl mx-auto px-6">
        <div data-reveal className="text-center mb-14">
          <div className="inline-flex items-center gap-2 mb-5 text-xs font-semibold uppercase tracking-[0.2em] text-[#D32F2F]">
            <span className="w-1.5 h-1.5 rounded-full bg-[#D32F2F]" /> Common Questions
          </div>
          <h2 className="font-head text-4xl sm:text-5xl font-semibold tracking-tight text-[#0F172A]">
            For boards &amp; managers.
          </h2>
        </div>
        <div className="divide-y divide-[#0F172A]/[0.08] border-y border-[#0F172A]/[0.08]">
          {FAQS.map(([q, a], i) => (
            <div key={i} data-testid={`faq-${i}`}>
              <button onClick={() => setOpen(open === i ? -1 : i)}
                      className="w-full flex items-center justify-between gap-4 py-5 text-left">
                <span className="font-head text-lg font-semibold text-[#0F172A]">{q}</span>
                <span className="shrink-0 w-8 h-8 rounded-full bg-[#F1F5F9] flex items-center justify-center">
                  {open === i ? <Minus className="w-4 h-4 text-[#D32F2F]" /> : <Plus className="w-4 h-4 text-[#0F172A]" />}
                </span>
              </button>
              {open === i && <p className="text-[15px] text-[#0F172A]/60 leading-relaxed pb-6 -mt-1 pr-12">{a}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { Coverage, FAQ };
